import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { showFlyout } from '../../../Dashboard/actions';
import { getFlyout } from '../../../Dashboard/selectors';
import { upDirection, downDirection } from '../../../Common/constants';
import { useAction } from '../../../Common/hooks';
import { rejectedFlyout } from '../../constants';
import { setCurrentSelectedRejected, setGridSortCriteria } from '../../actions';
import { getRejectedGridSortCriteria } from '../../selectors';

const useRejectedList = () => {
  const [activeRow, setActiveRow] = useState(undefined);
  const flyout = useSelector(getFlyout);
  const { sortByColumn, sortDirection } = useSelector(getRejectedGridSortCriteria);
  const dispatchShowFlyout = useAction(showFlyout);
  const dispatchSelectedRejected = useAction(setCurrentSelectedRejected);
  const dispatchGridSortCriteria = useAction(setGridSortCriteria);

  useEffect(() => {
    if (flyout.show === false) {
      setActiveRow(null);
    }
  }, [flyout]);

  const handleRowClick = row => {
    setActiveRow(undefined);
    dispatchShowFlyout(rejectedFlyout);
    dispatchSelectedRejected(row);
  };

  const handleColumnClick = ({ headerName, direction }) => {
    dispatchGridSortCriteria({
      sortByColumn: headerName,
      sortDirection: direction === upDirection ? downDirection : upDirection,
    });
  };

  return {
    handleRowClick,
    activeRow,
    handleColumnClick,
    sortByColumn,
    sortDirection,
  };
};

export default useRejectedList;
